import {
  ETable,
  ETableBody,
  ETableCell,
  ETableCellCheckbox,
  ETableCellInput,
  ETableHead,
  ETableHeader,
  ETableRow,
} from "@/shared/components/tables/e-table";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { PlusCircle, Trash2 } from "lucide-react";
import {
  MoldDifferentiation,
  newMoldDifferentiation,
} from "@/services/backend/samples/types/mold-differentiation";
import t from "@/lang/lang";

export function MoldDifferentiationDialog({
  moldDifferentiation,
  onMoldDifferentiationChange,
  disabled,
}: {
  moldDifferentiation: MoldDifferentiation[];
  onMoldDifferentiationChange: (
    moldDifferentiation: MoldDifferentiation[],
  ) => void;
  disabled: boolean;
}) {
  const add = () => {
    onMoldDifferentiationChange([
      ...moldDifferentiation,
      newMoldDifferentiation(),
    ]);
  };

  const update = (index: number, next: MoldDifferentiation) => {
    onMoldDifferentiationChange(
      moldDifferentiation.map((m, i) => (i === index ? next : m)),
    );
  };

  const remove = (index: number) => {
    onMoldDifferentiationChange(
      moldDifferentiation.filter((_, i) => i !== index),
    );
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="border-none shadow-none">
          {t("Differenzierung")}
        </Button>
      </DialogTrigger>
      <DialogContent className="min-w-fit">
        <DialogHeader>
          <DialogTitle>{t("Schimmelpilzdifferenzierung")}</DialogTitle>
        </DialogHeader>
        <ETable>
          <ETableHeader>
            <ETableRow>
              <ETableHead>{t("Pilz")}</ETableHead>
              <ETableHead className="w-28">{t("Wert")}</ETableHead>
              <ETableHead className="w-40">{t("Einheit")}</ETableHead>
              <ETableHead>{t("Überwachsen")}</ETableHead>
              <ETableHead />
            </ETableRow>
          </ETableHeader>
          <ETableBody>
            {moldDifferentiation.map((m, index) => (
              <ETableRow key={index}>
                <ETableCellInput
                  value={m.description}
                  onChange={(e) =>
                    update(index, { ...m, description: e.target.value })
                  }
                  disabled={disabled}
                />
                <ETableCellInput
                  value={m.value}
                  onChange={(e) =>
                    update(index, { ...m, value: e.target.value })
                  }
                  disabled={disabled}
                />
                <ETableCellInput
                  value={m.unit}
                  onChange={(e) =>
                    update(index, { ...m, unit: e.target.value })
                  }
                  disabled={disabled}
                />
                <ETableCellCheckbox
                  checked={m.overgrown}
                  onCheckedChange={(overgrown) =>
                    update(index, { ...m, overgrown: Boolean(overgrown) })
                  }
                  disabled={disabled}
                />
                <ETableCell className="text-right">
                  <Button
                    size="sm"
                    variant="destructive"
                    onClick={() => remove(index)}
                    disabled={disabled}
                  >
                    <Trash2 className="h-5 w-5" />
                  </Button>
                </ETableCell>
              </ETableRow>
            ))}
          </ETableBody>
        </ETable>
        <DialogFooter>
          <Button size="sm" onClick={add} disabled={disabled}>
            <PlusCircle className="mr-2 h-5 w-5" />
            <span>{t("Schimmelpilz")}</span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
